import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import Header from "./../include/Header";
import Apihelpers from './../helper/ApiHelper';
import SourceCreate from './SourceCreate';
import SourceEdit from './SourceEdit';
import SourceView from './SourceView';
//import {GET_MASTER_SERVICE_LIST } from './../helper/Constants';


class SourceList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPopUp: false,
      lastSequence:0,
      editRecord:{
        id:"",
        sr:0,
        key: "",
        name: "",
        type:"",
        price:0,
        status:true,
        token:'',
        url:'',
        email:'',
        curl:''
      },
      editPopUp: false,
      loader: false,
      filters:{
        page:0,
        limit:10,
        totalCount:0
      },
      listData:[],
      allPlans:[],
      viewRecord:{},
      viewPopUp: false
    }
    this.togglePopUp = this.togglePopUp.bind(this);
    this.loadPlanes = this.loadPlanes.bind(this);
    this.toggleLoader = this.toggleLoader.bind(this);
    this.editTogglePopup = this.editTogglePopup.bind(this);
    this.viewTogglePopup = this.viewTogglePopup.bind(this);
  }

  togglePopUp() {
    //console.log('call popup toggle');
    this.setState(state => ({
      showPopUp: !state.showPopUp
    }));
  }
  editTogglePopup() {
    this.setState({editPopUp: !this.state.editPopUp})
  }
  viewTogglePopup() {
    this.setState({viewPopUp: !this.state.viewPopUp})
  }
  toggleLoader(){
    //console.log('call load fun...');
    this.setState({loader: ! this.state.loader });
  }

  componentDidMount() {
    this.getPlanList();
    this.loadPlanes();
  }

  //load plans list
  getPlanList = () => {
    Apihelpers.getdataresponse('allservices').then(res => {
      //console.log('res.data',res.data);
      if (res.data.status === true) {
        let plans = [];
        res.data.data.forEach((pln)=>{
          plans.push({'sr':pln.service_sequence, 'key':pln.serviceName, 'label':pln.service_name})
        })
        this.setState({
          allPlans:plans
        })
      }
    });
  }

  loadPlanes = () => {
    let parmes = '?limit='+this.state.filters.limit+'&skip='+(this.state.filters.limit * this.state.filters.page);
    this.setState({loader: true });
    Apihelpers.getdataresponse('allsources/get-source-list'+parmes).then(res => {
      //console.log('res.data',res.data);
      if (res.data.status === true) {
        let data = res.data.data;
        //console.log('aaaaaaaaaaaaa',data.totalCount);
        let lastSeq = data.lastSequence;
        if(lastSeq === undefined) {
          lastSeq = 0;
        }
        this.setState({
          filters:{...this.state.filters, totalCount:data.totalCount},
          listData:data.record,
          lastSequence:(lastSeq+1)
        })
        this.toggleLoader();
      }
    });
  }

  loadPage = (e) => {
    let start = Number(e.target.getAttribute("data-i"));
    this.setState({
      filters: {...this.state.filters, page: start}
    });
    setTimeout(()=>{
      this.loadPlanes();
    },100);
  }
  changeLimit = (e) => {
    let limit = Number(e.target.value);
    this.setState({
      filters: {
        page:0,
        limit:limit,
        totalCount:0
      }
    });
    setTimeout(()=>{
      this.loadPlanes();
    },100);
  }

  render() {
    const renderPaging = () => {
      let pages = (this.state.filters.totalCount / this.state.filters.limit);
      //console.log('pages',pages);
      let pagingHmtl = [];
      for (var i = 0; pages > i; i++ ) {
        pagingHmtl.push(<span key={i} data-i={i} className={(this.state.filters.page == i) ? 'btn active' : 'btn'} onClick={(e)=>{this.loadPage(e)}}>{i+1}</span>);
      }
      return pagingHmtl;
    }
    return (
      <div className="wrapper serviceProvider">
        <Header />
        <div className="container">
          <div className="whiteBox">
            {
              //JSON.stringify(this.state.allPlans,null,2)
            }
            <div className="titleRow">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="title">Source List</h3>
                  <span className="desc">Showing {this.state.listData.length} out of {this.state.filters.totalCount}</span>
                </div>
                <div className="col-auto">
                  <a href="#" onClick={this.togglePopUp}><i className="fa fa-plus"></i> Add new source</a>
                </div>
              </div>
            </div>
            <div className="tableBorder">
              <table className="table">
                <thead>
                  <tr>
                    <th style={{width:'200px'}}>Sequence No. & Source Key</th>
                    <th>Vendor Name</th>
                    <th>Plans</th>
                    <th>Price</th>
                    <th>Status</th>
                    <th style={{width:'140px'}}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    this.state.listData.length > 0 ?
                      this.state.listData.map((item)=>{
                        return(
                          <tr key={item._id}>
                            <td><strong className="cr">{item.sequence}</strong> <span>{item.source_key}</span></td>
                            <td><span className="tt">{item.vendor_name}</span></td>
                            <td>
                              <div className="soruce-update">
                                {
                                  (item.plan_type?.length > 0) ?
                                    item.plan_type.map((tt)=>{
                                      let planObj = this.state.allPlans.filter((aa)=>(tt === aa.sr));
                                      return (<span key={tt} className="sourceitem">{planObj[0].key}</span>);
                                    })
                                  :
                                  ''
                                }
                              </div>
                            </td>
                            <td><strong>{item.price}</strong></td>
                            <td><span className="col-status"> {(item.status) ? 'Active' : 'InActive'}</span></td>
                            <td>
                              <NavLink title="Add Comments" className="btn-icon" to={"./source/comment/"+item._id}><i className="fa fa-commenting-o"></i></NavLink>
                              <button title="View Plan" className="btn-icon" onClick={()=>{
                                this.setState({viewRecord:item,viewPopUp:true})
                              }}><i className="fa fa-eye"></i></button>
                              <button className="btn-icon" onClick={()=>{
                                this.setState({
                                  editRecord: {
                                    id:item._id,
                                    sr:item.sequence,
                                    key: item.source_key,
                                    name: item.vendor_name,
                                    type:item.plan_type,
                                    price:item.price,
                                    status:item.status,
                                    token:item.token,
                                    url:item.api_url,
                                    email:item.email,
                                    curl:item.curl,
                                    info:item.contact_no
                                  },
                                  editPopUp: true,
                                  allPlans:this.state.allPlans
                                })
                              }} title="Edit Plan"><i className="fa fa-pencil-square-o"></i></button>
                            </td>
                          </tr>
                        )
                      })
                    :
                    <tr>
                      <td colSpan="8">Record Not Found...</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
            <div className="row">
              <div className="col">
                <div className="pageing">
                  {renderPaging()}
                </div>
              </div>
              <div className="col-auto">
                <select className="form-control" onChange={this.changeLimit} defaultValue={this.state.filters.limit}>
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="30">30</option>
                  <option value="40">40</option>
                  <option value="50">50</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        {
          this.state.showPopUp ?
          <SourceCreate plans={this.state.allPlans} lastSequence={this.state.lastSequence} togglePopUp={this.togglePopUp} loadPlanes={this.loadPlanes} toggleLoader={this.toggleLoader} />
          :""
        }

        {
          this.state.editPopUp ?
            <SourceEdit plans={this.state.allPlans} editTogglePopup={this.editTogglePopup} toggleLoader={this.toggleLoader} loadPlanes={this.loadPlanes} editRecord={this.state.editRecord} />
          :""
        }

        {
          this.state.viewPopUp ?
          <SourceView plans={this.state.allPlans} togglePopUp={this.viewTogglePopup} viewRecord={this.state.viewRecord} />
          :""
        }
        

        <div className="loader" style={{ display: `${this.state.loader ? 'block' : 'none'}`, zIndex:'111'}}>
          <div className="bg" />
          <img className="loadingImg" src="/assets/images/loading.gif"  alt="" />
        </div>
      </div>
    )
  }
}

export default SourceList;